/** Preposições e artigos que permanecem em minúsculas (exceto no início). */
const PALAVRAS_MINUSCULAS = new Set([
  'a',
  'as',
  'o',
  'os',
  'da',
  'de',
  'das',
  'dos',
  'do',
  'e',
  'em',
  'na',
  'no',
  'nas',
  'nos',
]);

function temLetra(texto: string): boolean {
  return /[a-zA-ZÀ-ÿ]/.test(texto);
}

function extrairLetras(texto: string): string {
  return texto.replace(/[^a-zA-ZÀ-ÿ]/g, '');
}

function isTodoMaiusculo(texto: string): boolean {
  const letras = extrairLetras(texto);
  return letras.length > 0 && letras === letras.toUpperCase();
}

function isTodoMinusculo(texto: string): boolean {
  const letras = extrairLetras(texto);
  return letras.length > 0 && letras === letras.toLowerCase();
}

function capitalizarPalavra(palavra: string): string {
  if (!palavra) return palavra;
  return palavra.charAt(0).toUpperCase() + palavra.slice(1);
}

/**
 * Formata nome próprio quando digitado todo em MAIÚSCULAS ou minúsculas.
 * Ex.: "CONDOMINIO JARDINS DA FRANCA" → "Condominio Jardins da Franca"
 * Palavras já em formato misto são preservadas.
 */
export function formatNomeProprio(value: string | null | undefined): string {
  if (value == null) return '';
  const trimmed = value.trim().replace(/\s+/g, ' ');
  if (!trimmed || !temLetra(trimmed)) return trimmed;

  if (!isTodoMaiusculo(trimmed) && !isTodoMinusculo(trimmed)) {
    return trimmed;
  }

  const palavras = trimmed.toLowerCase().split(' ');
  return palavras
    .map((palavra, index) => {
      if (!palavra) return palavra;
      const base = palavra.split('-').map((parte, parteIndex) => {
        if (!parte) return parte;
        const deveMinuscula =
          index > 0 && parteIndex === 0 && PALAVRAS_MINUSCULAS.has(parte);
        if (deveMinuscula) return parte;
        return capitalizarPalavra(parte);
      });
      return base.join('-');
    })
    .join(' ');
}
